/**
 * Conditional founder-pathway fields shown when the lead has no concrete location yet.
 * Renders inline within the LeadForm to keep the existing visual flow.
 */

const OPERATOR_EXPERIENCE = [
  { v: "yes", l: "Ja, ich habe Betreibererfahrung" },
  { v: "partial", l: "Teilweise / in verwandten Bereichen" },
  { v: "no", l: "Nein, ich bin Quereinsteiger" },
];

const FOUNDER_ROLES = [
  { v: "operate", l: "Selbst betreiben" },
  { v: "invest", l: "Investieren" },
  { v: "develop", l: "Standort entwickeln" },
  { v: "partner", l: "Mit Partner betreiben" },
  { v: "open", l: "Noch offen" },
];

const SEARCH_STATES = [
  { v: "active", l: "Ja, aktiv in Suche" },
  { v: "not_started", l: "Noch nicht gestartet" },
  { v: "multiple", l: "Mehrere Optionen in Prüfung" },
  { v: "open", l: "Noch offen" },
];

const SYSTEM_OPTIONS = ["PVRA", "AR_ENA", "PINE VR", "Hotel VR", "PINE Places", "Noch unklar"];

function Select({ label, name, value, onChange, options, testId }) {
  return (
    <div>
      <label className="field-label">{label}</label>
      <select
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        className="field"
        data-testid={testId}
      >
        <option value="">Bitte wählen</option>
        {options.map((opt) => (
          <option key={opt.v} value={opt.v}>{opt.l}</option>
        ))}
      </select>
    </div>
  );
}

function Input({ label, name, value, onChange, placeholder, testId }) {
  return (
    <div>
      <label className="field-label">{label}</label>
      <input
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        className="field"
        placeholder={placeholder}
        data-testid={testId}
      />
    </div>
  );
}

export default function LeadFormFounderFields({ data, set }) {
  const selected = (data.system_interests || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

  const toggleSystem = (sys) => {
    const next = selected.includes(sys)
      ? selected.filter((s) => s !== sys)
      : [...selected, sys];
    set("system_interests", next.join(", "));
  };

  return (
    <div
      className="border border-[#18E096]/40 bg-[#0B0F10] p-5 md:p-7 mt-2"
      data-testid="founder-fields"
    >
      <div className="overline mb-2 text-[#18E096]">Gründerpfad</div>
      <p className="text-[#AEB7B7] text-sm mb-6 leading-relaxed">
        Sie haben noch keine konkrete Fläche? Diese Angaben helfen uns, Ihre
        Gründungsidee, Region und Rolle strukturiert einzuordnen.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <Input
          label="Wunschregion / Stadt"
          name="wish_region"
          value={data.wish_region || ""}
          onChange={set}
          placeholder="z. B. Hamburg, Großraum NRW, Süddeutschland"
          testId="input-wish-region"
        />
        <Select
          label="Betreibererfahrung"
          name="operator_experience"
          value={data.operator_experience || ""}
          onChange={set}
          options={OPERATOR_EXPERIENCE}
          testId="select-operator-experience"
        />
        <Select
          label="Welche Rolle möchten Sie übernehmen?"
          name="founder_role"
          value={data.founder_role || ""}
          onChange={set}
          options={FOUNDER_ROLES}
          testId="select-founder-role"
        />
        <Select
          label="Sind Sie bereits in Standortsuche?"
          name="location_search_status"
          value={data.location_search_status || ""}
          onChange={set}
          options={SEARCH_STATES}
          testId="select-location-search-status"
        />
      </div>

      <div className="mt-6">
        <label className="field-label">Welche Systemprofile interessieren Sie?</label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-2">
          {SYSTEM_OPTIONS.map((sys) => {
            const active = selected.includes(sys);
            return (
              <button
                key={sys}
                type="button"
                onClick={() => toggleSystem(sys)}
                data-testid={`system-interest-${sys.toLowerCase().replace(/[_\s]/g, "-")}`}
                className={`text-left px-4 py-3 border text-sm transition-colors ${
                  active
                    ? "border-[#18E096] bg-[#18E096]/10 text-white"
                    : "border-[rgba(255,255,255,0.12)] text-[#AEB7B7] hover:border-[#18E096]/60 hover:text-white"
                }`}
              >
                {sys}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
